import { useEffect, useState } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummariesForCatalog, getItemSummaryIndex } from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    catalogId: number;
    itemId: number;
};

export const useFindLiveItemIndex = ({ catalogId, itemId }: Props) => {
    const items = useAppSelector((state) => getItemSummariesForCatalog(state, catalogId));
    const index = useAppSelector((state) => getItemSummaryIndex(state, itemId));
    const [liveItemIndex, setLiveItemIndex] = useState(index);

    useEffect(() => {
        const currItemIndex = items.findIndex((i) => i.itemId === itemId);
        if (currItemIndex > -1) {
            setLiveItemIndex(currItemIndex);
        }
    }, [itemId, items]);

    return liveItemIndex;
};
